/*
 * @Author: chenmengyao
 */
import request from '@/router/axios';

export const getList = (current, size, params, search) => {
    return request({
        url: '/api/blade-loanCarManage/loanCarManage/sellCarCollection',
        method: 'post',
        data: {
            ...params,
            ...search,
            current,
            size
        }
    })
}

export const getDetail = (id) => {
    return request({
        url: `/api/blade-loanCarManage/loanCarManage/sellCarCollectionDetail/${id}`,
        method: 'get'
    })
}

export const sellCarSubmit = (data) => {
    return request({
        url: '/api/blade-loanCarManage/loanCarManage/sellCarSubmit',
        method: 'post',
        data
    })
}

export const rejectSellCar = (data) => {
  return request({
      url: '/api/blade-loanCarManage/loanCarManage/rejectSellCar',
      method: 'post',
      data
  })
}